module.exports = __webpack_public_path__ + "static/img/p3.cbcc4f5a.png";